import styled from 'styled-components';
import { Table } from 'ui/table';
import { ColumnData, TableHeader } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import { body2, spacing } from 'ui/theme';
import noop from 'utils/noop';
import { ASCENDING } from 'constants/sortDirections';

type RowContent = {
  row: {
    col1: string;
    col2: string;
    col3: string;
    col4: string;
    col5: string;
    col6: string;
    col7: string;
    col8: string;
  };
};

interface CSVInput {
  csvInput: string;
  setRowCount: (value: number) => number;
}

const Cell = styled.div`
  ${body2};
  box-sizing: border-box;
  display: table-cell;
  overflow-y: visible;
  padding: ${spacing.threeQuarter};
`;

const HighlightedTableCell = styled(Cell)`
  color: #59c1a7;
  font-weight: bold;
`;

const StyledTable = styled(Table)`
  margin-top: ${spacing.double};
`;

export const CSVInputPreview = ({ csvInput, setRowCount }: CSVInput) => {
  return (
    <div>
      {csvInput && csvInput.split('\n')[0].split(',')[0].toLowerCase() === 'email' ? (
        <div>
          <div>
            {setRowCount(csvInput.split('\n').length - 1)}
            Preview - Showing {csvInput.split('\n').length - 1} user with{' '}
            {csvInput.split('\n')[0].split(',').length} field
          </div>
          <StyledTable>
            <TableRows
              columns={[
                {
                  name: 'col1',
                  value: 'col1',
                  align: 'flex-start',
                  sortable: false,
                  RowCell: ({ row }: RowContent) => <Cell>{row.col1}</Cell>,
                } as ColumnData,
                {
                  name: 'col2',
                  value: 'col2',
                  align: 'flex-start',
                  sortable: false,
                  RowCell: ({ row }: RowContent) => <Cell>{row.col2}</Cell>,
                } as ColumnData,
                {
                  name: 'col3',
                  value: 'col3',
                  align: 'flex-start',
                  sortable: false,
                  RowCell: ({ row }: RowContent) => <Cell>{row.col3}</Cell>,
                } as ColumnData,
                {
                  name: 'col4',
                  value: 'col4',
                  align: 'flex-start',
                  sortable: false,
                  RowCell: ({ row }: RowContent) => <Cell>{row.col4}</Cell>,
                } as ColumnData,
                {
                  name: 'col5',
                  value: 'col5',
                  align: 'flex-start',
                  sortable: false,
                  RowCell: ({ row }: RowContent) => <Cell>{row.col5}</Cell>,
                } as ColumnData,
                {
                  name: 'col6',
                  value: 'col6',
                  align: 'flex-start',
                  sortable: false,
                  RowCell: ({ row }: RowContent) => <Cell>{row.col6}</Cell>,
                } as ColumnData,
                {
                  name: 'col7',
                  value: 'col7',
                  align: 'flex-start',
                  sortable: false,
                  RowCell: ({ row }: RowContent) => <Cell>{row.col7}</Cell>,
                } as ColumnData,
                {
                  name: 'col8',
                  value: 'col8',
                  align: 'flex-start',
                  sortable: false,
                  RowCell: ({ row }: RowContent) => <Cell>{row.col8}</Cell>,
                } as ColumnData,
              ]}
              rows={csvInput.split('\n').map((element, index) => {
                return {
                  id: index,
                  col1: element.split(',')[0],
                  col2: element.split(',')[1],
                  col3: element.split(',')[2],
                  col4: element.split(',')[3],
                  col5: element.split(',')[4],
                  col6: element.split(',')[5],
                  col7: element.split(',')[6],
                  col8: element.split(',')[7],
                };
              })}
              selectedRows={[]}
            />
          </StyledTable>
        </div>
      ) : (
        <div>
          <div>
            {setRowCount(csvInput.split('\n').length)}
            Preview - Showing {csvInput.split('\n').length} user with{' '}
            {csvInput.split('\n')[0].split(',').length} field
          </div>
          <StyledTable>
            <TableHeader
              columns={[
                {
                  name: 'Email (Required)',
                  value: 'email',
                  align: 'flex-start',
                  sortable: false,
                  RowCell: ({ row }: RowContent) => (
                    <HighlightedTableCell>{row.col1}</HighlightedTableCell>
                  ),
                } as ColumnData,
              ]}
              setSortedBy={noop}
              setSortDirection={noop}
              sortedBy={''}
              sortDirection={ASCENDING}
            />
            <TableRows
              columns={[
                {
                  name: 'col1',
                  value: 'col1',
                  align: 'flex-start',
                  sortable: false,
                  RowCell: ({ row }: RowContent) => <Cell>{row.col1}</Cell>,
                } as ColumnData,
                {
                  name: 'col2',
                  value: 'col2',
                  align: 'flex-start',
                  sortable: false,
                  RowCell: ({ row }: RowContent) => <Cell>{row.col2}</Cell>,
                } as ColumnData,
                {
                  name: 'col3',
                  value: 'col3',
                  align: 'flex-start',
                  sortable: false,
                  RowCell: ({ row }: RowContent) => <Cell>{row.col3}</Cell>,
                } as ColumnData,
                {
                  name: 'col4',
                  value: 'col4',
                  align: 'flex-start',
                  sortable: false,
                  RowCell: ({ row }: RowContent) => <Cell>{row.col4}</Cell>,
                } as ColumnData,
                {
                  name: 'col5',
                  value: 'col5',
                  align: 'flex-start',
                  sortable: false,
                  RowCell: ({ row }: RowContent) => <Cell>{row.col5}</Cell>,
                } as ColumnData,
                {
                  name: 'col6',
                  value: 'col6',
                  align: 'flex-start',
                  sortable: false,
                  RowCell: ({ row }: RowContent) => <Cell>{row.col6}</Cell>,
                } as ColumnData,
                {
                  name: 'col7',
                  value: 'col7',
                  align: 'flex-start',
                  sortable: false,
                  RowCell: ({ row }: RowContent) => <Cell>{row.col7}</Cell>,
                } as ColumnData,
                {
                  name: 'col8',
                  value: 'col8',
                  align: 'flex-start',
                  sortable: false,
                  RowCell: ({ row }: RowContent) => <Cell>{row.col8}</Cell>,
                } as ColumnData,
              ]}
              rows={csvInput.split('\n').map((element, index) => {
                return {
                  id: index,
                  col1: element.split(',')[0],
                  col2: element.split(',')[1],
                  col3: element.split(',')[2],
                  col4: element.split(',')[3],
                  col5: element.split(',')[4],
                  col6: element.split(',')[5],
                  col7: element.split(',')[6],
                  col8: element.split(',')[7],
                };
              })}
              selectedRows={[]}
            />
          </StyledTable>
        </div>
      )}
    </div>
  );
};
